export const updateURLParam = (oldParam, newParam) => {
  const currentUrl = window.location.href;
  const newUrl = currentUrl.replace(oldParam, newParam);

  // Use the pushState method of the History API to change the URL without refreshing the page
  history.replaceState(null, '', newUrl);
}

export const updateURLQueryParam = (key, value, isDelete) => {
  const searchParams = new URLSearchParams(window.location.search);
  if (isDelete) searchParams.delete(key);
  else searchParams.set(key, value);

  if (searchParams.size) {
    const newRelativePathQuery = window.location.pathname + '?' + encodeURI(searchParams.toString());
    history.replaceState(history.state, '', newRelativePathQuery);
  } else {
    history.replaceState(history.state, '', window.location.pathname);
  }
}
